(function () {
  'use strict';

  angular
    .module('exports.exports')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('exports', {
        abstract: true,
        url: '/exports',
        template: '<ui-view />'
      });
  }
}());
